module.exports = __webpack_public_path__ + "static/img/colse_eyes.1091f47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colse_eyes.png
// module id = 5iGa
// module chunks = 1